import { useTheme } from 'styled-components';
import {
  Amount,
  InnerCircle,
  InnerCircleLoader,
  PieChartLoaderWrapper,
  StyledLoader,
  Text,
} from './styles';

export const PieChartLoader = () => {
  const { colors } = useTheme();

  return (
    <PieChartLoaderWrapper>
      <StyledLoader
        viewBox="0 0 200 200"
        backgroundColor={colors.surface.interactiveDefault}
        foregroundColor={colors.surface.pressed}
      >
        <circle cx="100" cy="100" r="90" />
      </StyledLoader>

      <InnerCircle>
        <InnerCircleLoader>
          <Text />
          <Amount />
        </InnerCircleLoader>
      </InnerCircle>
    </PieChartLoaderWrapper>
  );
};
